export default __webpack_public_path__ + "static/magic-sync-feature-a-874492a2c0eadbc46ce44144c324cd65.webp";